import styled from '../../styled-components';
import { P, Modal, Title } from '@meindach/ui-kit';

export const StyledModal = styled(Modal)`
  max-width: 410px;
  margin: 0 auto;
`;

export const Name = styled(Title)`
  margin: 0;
`;

export const Header = styled.div`
  padding: ${({ theme }) => theme.spacing.m};
  display: flex;
  flex-wrap: wrap;

  > div {
    &:first-child {
      flex: 0;
      margin-right: ${({ theme }) => theme.spacing.m};
    }
    &:nth-child(2) {
      flex: 1;
    }
  }
  > a {
    display: flex;
    align-items: center;
    margin-left: ${({ theme }) => theme.spacing.m};
  }
`;

export const CloseContainer = styled.div`
  display: flex;
  align-items: center;
  height: 52px;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.spacing.m};
  padding-bottom: 0;

  > svg,
  > ${P} {
    cursor: pointer;
  }
  &,
  > ${P} {
    color: ${({ theme }) => theme.color.blue};
  }
  > ${P} {
    font-weight: 600;
    margin: 0;
    padding: ${({ theme }) => theme.spacing.s} 0;
  }
  > svg {
    width: 16px;
    height: 20px;
    transform: rotate(180deg);
    padding: ${({ theme }) => theme.spacing.s};
    margin-left: -${({ theme }) => theme.spacing.s};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;

  ${Name} {
    margin: 0;
  }
  ${P} {
    margin: 0;
    display: flex;
    align-items: center;

    > svg {
      width: 20px;
      height: 20px;
      margin-left: -${({ theme }) => theme.spacing.xs};
    }
  }
`;

export const Entry = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color.mercury};
  display: flex;

  > ${P} {
    flex: 70;
    margin: ${({ theme }) => theme.spacing.s} 0;

    &:first-child {
      flex: 30;
      display: flex;
      color: ${({ theme }) => theme.color.silver};
    }

    > svg {
      margin-right: ${({ theme }) => theme.spacing.s};
      width: 25px;
      height: 25px;
    }
  }

  &:last-of-type {
    border-bottom: none;
  }
`;

export const Details = styled.div`
  padding: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.m};

  > ${P} {
    font-size: 16px;
    margin: 0;
    line-height: 43px;
    border-bottom: 1px solid ${({ theme }) => theme.color.mercury};
  }
`;

export const Action = styled.a`
  border-bottom: 1px solid ${({ theme }) => theme.color.mercury};
  height: 43px;
  display: flex;
  align-items: center;

  > * {
    color: ${({ theme }) => theme.color.blue};
  }

  > ${P} {
    font-weight: 600;
  }

  > svg {
    margin-right: ${({ theme }) => theme.spacing.s};
    width: 25px;
    height: 25px;
  }
`;

export const MapContainer = styled.div`
  width: 100%;
  height: 340px;
  pointer-events: none;
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const Counties = styled(Entry)`
  > svg {
    color: ${({ theme }) => theme.color.storm};
    margin-right: ${({ theme }) => theme.spacing.s};
    width: 25px;
    height: 25px;
  }
  > div {
    flex: 70;
    > * {
      margin-right: ${({ theme }) => theme.spacing.s};
      margin-bottom: ${({ theme }) => theme.spacing.s};
    }
  }
`;
